import template from './affiliates-filter.html';
import AffiliatesFilterController from './affiliates-filter.controller';
import './affiliates-filter.styl';

let affiliatesFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: AffiliatesFilterController,
  controllerAs: 'vm'
};

export default affiliatesFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/affiliates-filter/affiliates-filter.component.js
 **/